<template>
  <div class="candidates-tab">
    <div class="candidates-tab__table">
      <div class="table-panel">
        <Input
          v-if="quickSearchInput"
          :field="{
            name: quickSearchInput.name,
            type: 'text',
            placeholder: quickSearchInput.placeholder
          }"
          size="big"
          :model="search"
          prefixIcon="Search"
          :noBorder="true"
          class="table-panel__search"
          @set-value="handleChange"
        />
        <div class="table-panel__buttons">
          <div
            v-for="item in rightButtons"
            v-show="
              item.name != 'HRPAC_CANDIDATES_MASS_ACTION' ||
              (item.name == 'HRPAC_CANDIDATES_MASS_ACTION' &&
                getLengthChangeableList)
            "
            :key="item.id"
            class="shadow-level-1"
          >
            <Button
              v-if="item.name === 'HRPAC_CANDIDATES_MASS_OPTIONS'"
              :buttonSize="item.sizeVisualClass"
              :buttonColor="
                getVisibleChangeable ? 'darkBlue' : item.colorVisualClass
              "
              hasLeftIcon
              :iconSrc="item.icon"
              @click="setChangeable"
            />
            <mass-action-dropdown
              v-else-if="item.name == 'HRPAC_CANDIDATES_MASS_ACTION'"
              :actions="item.child"
              :menuColor="item.colorVisualClass"
              :iconUrl="item.icon"
              :buttonText="item.lbl.value"
              :hideOnClick="false"
              @handleCommand="checkActions"
            />

            <div
              v-else-if="
                item.name && item.name !== 'HRPAC_CANDIDATES_MASS_ACTION'
              "
              class="button-wrapper"
            >
              <div
                v-if="item.name == 'HRPAC_CANDIDATES_FILTERS' && filtersActive"
                class="red-circle"
              ></div>
              <div
                v-if="item.name == 'HRPAC_CANDIDATES_SORT' && sortActive"
                class="red-circle"
              ></div>

              <FormButtons
                :key="buttonsUpdateKey"
                :buttons_menu="[[item]]"
                topPanel
                view-type="detail"
              ></FormButtons>
            </div>
          </div>
        </div>
      </div>
      <Table
        v-if="tableData[module]"
        :key="`${
          tableData[module].rows.length
            ? tableData[module].rows[0]['ID'] || 0
            : 0
        }_${
          tableColumn && Object.keys(tableColumn).length
            ? Object.keys(tableColumn).length
            : 0
        }`"
        editableColumns
        singleSelect
        :multipleSelect="getChangeableListView"
        @handleMultiSelection="changeChangeableList"
        :module="module"
        :emptyText="
          tableData[module].rows.length == 0 &&
          (filtersActive ||
            sortActive ||
            (stagesSearchActive && stagesSearchActive.length))
            ? 'Не нашли кандидатов по выставленным параметрам. Попробуйте изменить параметры поиска.'
            : 'Кандидаты еще не были добавлены. Вы можете добавить их с помощью кнопки выше'
        "
        class="table-panel__list shadow-level-1"
      />
      <FilterDialog
        v-if="is_visible.filters_dialog"
        :is_visible="is_visible.filters_dialog"
        :moduleName="module"
      />
      <SortDialog
        v-if="is_visible.sort_dialog"
        :is_visible="is_visible.sort_dialog"
        :moduleName="module"
      />
    </div>
    <CandidateCard
      v-if="selectedVacancyCandidate"
      :candidateId="selectedVacancyCandidate.ID"
      class="table-panel__candidate shadow-level-1"
    />
  </div>
</template>

<script>
import { store } from '@/store';
import { eventBus } from '@/bus';
import FormButtons from 'Elements/Form/FormButtons';
import Input from 'Elements/Input/Input';
import Table from 'Elements/Table/Table';
import Button from 'Elements/Button/Button';
import FilterDialog from 'Elements/Dialog/FilterDialog';
import SortDialog from 'Elements/Dialog/SortDialog';
import CandidateCard from 'Parts/Candidate/View/CandidateCardNew';
import { mixin, errorMsg } from '@/utils/mixins';
import { EVENTBUS_EVENTS, INTENT_AREA, ACTION } from '@/utils/constants';
import MassActionDropdown from 'Elements/Select/MassActionDropdown';

export default {
  mixins: [mixin, errorMsg],
  created() {
    store.commit('candidate/setChangeableVacCandList', []);
    store.commit('filters/setFilterPopupMetaData', {});
    if (store.state.subpanels.activeSubpanelData?.candidates?.custom_search) {
      store.commit(
        'filters/setFiltersConfig',
        store.state.subpanels.activeSubpanelData.candidates.custom_search
      );
      store.commit('filters/setParam', {
        name: 'sortActive',
        val: !store.state.subpanels.activeSubpanelData.candidates.custom_search
          .sortable.default
      });
    }

    store.commit(
      'selectionPopup/setBaseParams',
      {
        module: 'vacancy_candidates',
        action: ACTION.LIST_VIEW,
        jsqon_return: 1,
        to_pdf: true,
        query: true
      },
      { root: true }
    );
    eventBus.$on(INTENT_AREA.SEND_REQUEST, () => {
      eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, 'candidates');
    });
    eventBus.$on(EVENTBUS_EVENTS.SHOW_SUCCESS, text => {
      this.showNotification({
        offset: 100,
        showClose: true,
        message: text,
        duration: 6500,
        type: 'success'
      });
    });
    eventBus.$on(EVENTBUS_EVENTS.SHOW_ERROR, text => {
      this.showNotification({
        offset: 100,
        showClose: true,
        message: text,
        duration: 6500,
        type: 'error'
      });
    });
    eventBus.$on(EVENTBUS_EVENTS.UPDATE_KEY, key => {
      if (key == 'buttonsUpdateKey') {
        this.buttonsUpdateKey++;
      }
    });
    store.commit('candidate/setParam', {
      name: 'metadata',
      val: {}
    });
  },
  beforeDestroy() {
    localStorage.removeItem('currentVacancyUserId');
    store.commit('vacancy/setParam', {
      name: 'currentVacancyCandidate',
      val: null
    });
    eventBus.$emit(EVENTBUS_EVENTS.TABLE_SELECTION_CLEAR);
    eventBus.$off(INTENT_AREA.SEND_REQUEST);
    eventBus.$off(EVENTBUS_EVENTS.SHOW_SUCCESS);
    eventBus.$off(EVENTBUS_EVENTS.SHOW_ERROR);
    eventBus.$off(EVENTBUS_EVENTS.UPDATE_KEY);
  },
  data() {
    return {
      search: '',
      module: 'vacancy_candidates',
      buttonsUpdateKey: 0
    };
  },
  methods: {
    setChangeable() {
      if (this.getVisibleChangeable) {
        store.commit('candidate/setChangeableVacCandList', []);
      }
      store.commit('candidate/setChangeableVacCandListVisible');
    },
    handleChange(name, value) {
      this.search = value;

      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        clearTimeout(this.timer);

        store.dispatch('common/fetchQuickSearch', {
          module: this.module,
          intents: this.quickSearchInput.intents[0].request,
          filters: {
            ...store.state.filters.filterConfig.filters,
            hidden_stage_ids: {
              name: 'hidden_stage_ids',
              value: store.state.rightPanel.hiddenStages
            }
          },
          search: this.search
        });
      }, 2000);

      store.commit('filters/setFiltersActive', value ? true : false);
    },
    changeChangeableList(items) {
      store.commit('candidate/setChangeableVacCandList', items);
    },
    async checkActions(item) {
      if (item?.id && item.id == 'hrpac_candidates_mass_add_to_vacancy') {
        let fixedIntent = { ...item.intents[0] };
        fixedIntent.request.dynamic_request_params.selected_ids =
          store.state.candidate.changeableVacCandList.list.map(elem => elem.ID);
        const url = this.createLinkFromIntent(fixedIntent.request);
        localStorage.setItem('AttachmentLink', url);
        store.dispatch('attachment/loadMassAttachmentData', fixedIntent);
        store.commit('candidate/setChangeableVacCandList', []);
        this.$router.push(
          `/vacancies/${fixedIntent?.request?.request_params?.vacancy_id}/AttachmentPage`
        );
      } else {
        store.dispatch('dialog/getPopupData', {
          item,
          list: this.selectedCandidates
        });
      }
    }
  },
  computed: {
    selectedCandidates() {
      return store.state.candidate.changeableVacCandList.list;
    },
    getLengthChangeableList() {
      return store.state.candidate.changeableVacCandList.list.length;
    },
    tableData() {
      return store.state.common.tableData || null;
    },
    tableColumn() {
      return store.state.common.tableFields || null;
    },
    quickSearchInput() {
      return (
        Object.values(
          store.state.subpanels.activeSubpanelData['candidates']?.data?.data
            ?.title?.title_buttons
        )[0] || null
      );
    },
    rightButtons() {
      let buttons = Object.values(
        store.state.subpanels.activeSubpanelData['candidates']?.data?.data
          ?.title?.title_buttons
      );
      return buttons.splice(1, buttons.length) || null;
    },
    tabData() {
      return store.state.subpanels.activeSubpanelData['candidates'];
    },
    getChangeableListView() {
      return store.state.candidate.changeableVacCandList.changeable;
    },
    filtersActive() {
      return store.state.filters.filtersActive;
    },
    sortActive() {
      return store.state.filters.sortActive;
    },
    stagesSearchActive() {
      return store.state.filters.filterAdditionalUrl['vacancy_candidates'];
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    getVisibleChangeable() {
      return store.state.candidate.changeableVacCandList.changeable;
    },
    selectedVacancyCandidate() {
      return store.state.vacancy.currentVacancyCandidate || null;
    }
  },
  components: {
    FormButtons,
    Input,
    Table,
    Button,
    FilterDialog,
    SortDialog,
    CandidateCard,
    MassActionDropdown
  }
};
</script>

<style lang="scss" scoped>
.candidates-tab,
.candidates-tab__table,
.table-panel,
.table-panel__buttons,
.table-panel__content {
  display: flex;
}

.candidates-tab__table {
  width: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: fill-available;
  flex-direction: column;
}

.candidates-tab {
  gap: 16px;

  &__table {
    gap: 20px;
    padding-left: 1px;
  }
}

.table-panel {
  justify-content: space-between;
  gap: 20px;

  &__search {
    max-width: 220px;
  }

  &__buttons {
    padding-right: 2px;
    gap: 16px;

    &--mass-actions {
      & > *:first-child:not(:last-of-type) {
        display: none;
      }
    }

    & ::v-deep .el-dropdown {
      height: 40px;
    }
  }

  &__content {
    gap: 16px;
  }

  &__list {
    height: calc(100vh - 229px);
  }

  &__candidate {
    height: auto;

    & ::v-deep .el-tabs__header {
      width: auto !important;
    }

    & ::v-deep .candidate-card__page {
      height: calc(100vh - 242px);
    }
  }
}

@media (max-width: 1199px) {
  .candidates-tab__table:not(:last-of-type) {
    display: none;
  }

  .table-panel__candidate {
    min-width: inherit;
  }
}

@media (min-width: 1199px) {
  .candidates-tab__table:not(:last-of-type) {
    max-width: 298px;
  }
}

@media (min-width: 1513px) {
  .candidates-tab__table:not(:last-of-type) {
    min-width: 504px;
  }

  .table-panel__candidate {
    min-width: 872px;
  }
}

.table-panel__list {
  @media (min-width: 1512px) {
    & > *:first-child:not(:last-of-type) {
      max-width: 503px;
    }
  }

  @media (max-width: 1200px) {
    & > *:first-child:not(:last-of-type) {
      display: none;
    }
  }
}

.button-wrapper {
  position: relative;
}

.red-circle {
  position: absolute;
  top: 5px;
  right: 9px;
  width: 6px;
  height: 6px;
  z-index: 10;
  border-radius: 100%;
  margin: 0 !important;
  background: $red;
}

.hidden {
  display: none;
}
</style>
